var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "el-table-infinite-scroll",
              rawName: "v-el-table-infinite-scroll",
              value: _vm.table_config.loadList,
              expression: "table_config.loadList",
            },
          ],
          staticClass: "scpc-task-table",
          attrs: {
            "row-key": "id",
            data: _vm.table_config.tableData,
            "cell-class-name": _vm.returnName,
            "cell-style": _vm.cellStyle,
            "header-cell-style": {
              background: "#f9f9f9",
              fontSize: "16px",
            },
            "row-style": { height: "38" },
            "row-class-name": _vm.tableRowClassName,
            lazy: "",
            load: _vm.loadChiTask,
            "tree-props": { children: "children", hasChildren: "hasChildren" },
            border: "",
          },
          on: { "row-click": _vm.rowFun, "selection-change": _vm.changeBox },
        },
        [
          _vm.checkbox
            ? _c("el-table-column", {
                attrs: { type: "selection", "min-width": "10%" },
              })
            : _vm._e(),
          _vm.tab === "todoTask"
            ? [
                _vm._l(_vm.table_config.theads, function (item) {
                  return [
                    item.prop === "taskname"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "320",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        scope.row.taskType === "1"
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    scope.row.nodeName +
                                                    "-" +
                                                    scope.row.taskname,
                                                  placement: "bottom",
                                                  "popper-class": "texttooltip",
                                                  "open-delay": 500,
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "scope-content-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.nodeName
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          scope.row.taskname
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content: scope.row.taskname,
                                                  placement: "bottom",
                                                  "popper-class": "texttooltip",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "scope-content-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.taskname
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                        _c(
                                          "span",
                                          { staticClass: "scpc-operate-icon" },
                                          [
                                            scope.row.overdueFlag == 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "task_within",
                                                  },
                                                  [_vm._v("逾")]
                                                )
                                              : _vm._e(),
                                            scope.row.collectFlag == "1"
                                              ? _c("span", [
                                                  _c("i", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .collectFlag == 1,
                                                        expression:
                                                          "scope.row.collectFlag == 1",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "iconfont icon-shoucang1",
                                                    staticStyle: {
                                                      color: "#ffb83e",
                                                      "margin-right": "12px",
                                                    },
                                                  }),
                                                ])
                                              : _vm._e(),
                                            scope.row.milestone === "1"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      padding: "0 6px",
                                                    },
                                                  },
                                                  [
                                                    scope.row.milestone == "1"
                                                      ? _c("i", {
                                                          staticClass:
                                                            "iconfont icon-lichengbei-qizhi drawer_icon",
                                                          staticStyle: {
                                                            color: "#2878ff",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                            scope.row.taskType === "1"
                                              ? _c("i", {
                                                  staticClass:
                                                    "iconfont icon-liuchengrenwu liuchen_icon",
                                                  staticStyle: {
                                                    color:
                                                      "rgba(28, 106, 235, 1)",
                                                    padding: "0 6px",
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.config.figureFun(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "subtaskTaskname"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "140",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.taskname,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.taskname)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "scpc-operate-icon" },
                                          [
                                            scope.row.overdueFlag == 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "task_within",
                                                  },
                                                  [_vm._v("逾")]
                                                )
                                              : _vm._e(),
                                            scope.row.collectFlag == "1"
                                              ? _c("span", [
                                                  _c("i", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .collectFlag == 1,
                                                        expression:
                                                          "scope.row.collectFlag == 1",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "iconfont icon-shoucang1",
                                                    staticStyle: {
                                                      color: "#ffb83e",
                                                      "margin-right": "12px",
                                                    },
                                                  }),
                                                ])
                                              : _vm._e(),
                                            scope.row.milestone === "1"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      padding: "0 6px",
                                                    },
                                                  },
                                                  [
                                                    scope.row.milestone == "1"
                                                      ? _c("i", {
                                                          staticClass:
                                                            "iconfont icon-lichengbei-qizhi drawer_icon",
                                                          staticStyle: {
                                                            color: "#2878ff",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                            scope.row.taskType === "1"
                                              ? _c("i", {
                                                  staticClass:
                                                    "iconfont icon-liuchengrenwu liuchen_icon",
                                                  staticStyle: {
                                                    color:
                                                      "rgba(28, 106, 235, 1)",
                                                    padding: "0 6px",
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.config.figureFun(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "correlationTaskname"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "35%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                scope.row.taskVo.taskname,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.taskVo.taskname
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "scpc-operate-icon" },
                                          [
                                            scope.row.taskVo.overdueFlag == 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "task_within",
                                                  },
                                                  [_vm._v("逾")]
                                                )
                                              : _vm._e(),
                                            scope.row.taskVo.collectFlag == "1"
                                              ? _c("span", [
                                                  _c("i", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row.taskVo
                                                            .collectFlag == 1,
                                                        expression:
                                                          "scope.row.taskVo.collectFlag == 1",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "iconfont icon-shoucang1",
                                                    staticStyle: {
                                                      color: "#ffb83e",
                                                      "margin-right": "12px",
                                                    },
                                                  }),
                                                ])
                                              : _vm._e(),
                                            scope.row.taskVo.milestone === "1"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      padding: "0 6px",
                                                    },
                                                  },
                                                  [
                                                    scope.row.taskVo
                                                      .milestone == "1"
                                                      ? _c("i", {
                                                          staticClass:
                                                            "iconfont icon-lichengbei-qizhi drawer_icon",
                                                          staticStyle: {
                                                            color: "#2878ff",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                            scope.row.taskVo.taskType === "1"
                                              ? _c("i", {
                                                  staticClass:
                                                    "iconfont icon-liuchengrenwu liuchen_icon",
                                                  staticStyle: {
                                                    color:
                                                      "rgba(28, 106, 235, 1)",
                                                    padding: "0 6px",
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.config.figureFun(
                                                        scope.row.taskVo
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "taskNumber"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "170",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "scope-content-id" },
                                      [_vm._v(_vm._s(scope.row.taskNumber))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "planEndDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "45%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.corpId ===
                                      "ding379884b8b194a55f35c2f4657eb6378f" &&
                                    scope.row.project
                                      ? _c(
                                          "span",
                                          { staticClass: "scope-content-id" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.project.planEndDate.substring(
                                                  0,
                                                  10
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "scope-content-id" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.proNumber &&
                                                  scope.row.planEndDate
                                                  ? scope.row.planEndDate.substring(
                                                      0,
                                                      10
                                                    )
                                                  : scope.row.planEndDate
                                              )
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "prodPlanEndDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "45%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return scope.row.prodPlanEndDate
                                    ? [
                                        _c(
                                          "span",
                                          { staticClass: "scope-content-id" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.prodPlanEndDate.substring(
                                                  0,
                                                  10
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    : undefined
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "subtaskPlanEndDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "220",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "scope-content-id" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.proNumber &&
                                              scope.row.planEndDate
                                              ? scope.row.planEndDate.substring(
                                                  0,
                                                  10
                                                )
                                              : scope.row.planEndDate
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "createUser"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "30%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "scpc-operate-photo",
                                            staticStyle: {
                                              "padding-right": "2px",
                                            },
                                          },
                                          [
                                            scope.row.createUser &&
                                            scope.row.createUser.avatar != "" &&
                                            scope.row.createUser.avatar !== null
                                              ? _c("div", [
                                                  _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      src: scope.row.createUser
                                                        .avatar,
                                                    },
                                                  }),
                                                ])
                                              : _c(
                                                  "div",
                                                  { staticClass: "img" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.createUser.name.substring(
                                                            0,
                                                            1
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid:
                                                      scope.row.createUser.name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.createUser.name
                                                  )
                                                ),
                                              ]
                                            ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "subtaskCreateUser"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "28%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "scpc-operate-photo",
                                            staticStyle: {
                                              "padding-right": "2px",
                                            },
                                          },
                                          [
                                            scope.row.createUser &&
                                            scope.row.createUser.avatar != "" &&
                                            scope.row.createUser.avatar !== null
                                              ? _c("div", [
                                                  _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      src: scope.row.createUser
                                                        .avatar,
                                                    },
                                                  }),
                                                ])
                                              : _c(
                                                  "div",
                                                  { staticClass: "img" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.createUser.name.substring(
                                                            0,
                                                            1
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid:
                                                      scope.row.createUser.name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.createUser.name
                                                  )
                                                ),
                                              ]
                                            ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "correlationCreateUser"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "28%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "scpc-operate-photo",
                                            staticStyle: {
                                              "padding-right": "2px",
                                            },
                                          },
                                          [
                                            scope.row.taskVo.createUser &&
                                            scope.row.taskVo.createUser
                                              .avatar != "" &&
                                            scope.row.taskVo.createUser
                                              .avatar !== null
                                              ? _c("div", [
                                                  _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      src: scope.row.taskVo
                                                        .createUser.avatar,
                                                    },
                                                  }),
                                                ])
                                              : _c(
                                                  "div",
                                                  { staticClass: "img" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.taskVo.createUser.name.substring(
                                                            0,
                                                            1
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid:
                                                      scope.row.taskVo
                                                        .createUser.name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.taskVo.createUser
                                                      .name
                                                  )
                                                ),
                                              ]
                                            ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "principalUser"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "120",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "scpc-operate-photo" },
                                          [
                                            scope.row.principalUser.avatar &&
                                            scope.row.principalUser.avatar !=
                                              "" &&
                                            scope.row.principalUser.avatar !=
                                              null
                                              ? _c("div", [
                                                  _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      src: scope.row
                                                        .principalUser.avatar,
                                                    },
                                                  }),
                                                ])
                                              : _c(
                                                  "div",
                                                  { staticClass: "img" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.principalUser.name.substring(
                                                            0,
                                                            1
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid:
                                                      scope.row.principalUser
                                                        .name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.principalUser.name
                                                  )
                                                ),
                                              ]
                                            ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "executorUserList"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "30%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          overflow: "hidden",
                                          "align-items": "center",
                                          "text-overflow": "ellipsis",
                                          "white-space": "nowrap",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "scpc-operate-photos",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  width: "6px",
                                                },
                                              },
                                              _vm._l(
                                                scope.row.executorUserList,
                                                function (item1, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "scope-content",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "scpc-operate-photo",
                                                        },
                                                        [
                                                          item1.avatar &&
                                                          item1.avatar != "" &&
                                                          item1.avatar != null
                                                            ? _c("div", [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: item1.avatar,
                                                                  },
                                                                }),
                                                              ])
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "img",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item1.name.substring(
                                                                          0,
                                                                          1
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "min-width": "55px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                  "white-space": "nowrap",
                                                  "margin-left": "8px",
                                                },
                                              },
                                              _vm._l(
                                                scope.row.executorUserList,
                                                function (item1, index) {
                                                  return _c(
                                                    "span",
                                                    { key: index },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "scope-content-text",
                                                        },
                                                        [
                                                          _vm.channel ===
                                                          "wechat"
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "ww-open-data",
                                                                    {
                                                                      attrs: {
                                                                        type: "userName",
                                                                        openid:
                                                                          item1.name,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item1.name
                                                                  )
                                                                ),
                                                              ]),
                                                          index <
                                                          scope.row
                                                            .executorUserList
                                                            .length -
                                                            1
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-right":
                                                                      "5px",
                                                                  },
                                                                },
                                                                [_vm._v(",")]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "planWorkTime"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "33%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        scope.row.planWorkTime == null ||
                                        scope.row.planWorkTime == ""
                                          ? _c("div", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "scope-content-text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.planWorkTime
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ])
                                          : _c("div", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "scope-content-text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.planWorkTime
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("span", [_vm._v("天")]),
                                            ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "taskType"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "150",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scope-content",
                                        staticStyle: {
                                          "justify-content": "center",
                                        },
                                      },
                                      [
                                        scope.row.proTypeId === "2001"
                                          ? _c("span", [_vm._v("敏捷任务")])
                                          : scope.row.taskType === "0"
                                          ? _c("span", [_vm._v("标准任务")])
                                          : scope.row.taskType === "1"
                                          ? _c("span", [_vm._v("流程任务")])
                                          : scope.row.proTypeId === "0"
                                          ? _c("span", [_vm._v("标准任务")])
                                          : scope.row.proTypeId === "1"
                                          ? _c("span", [_vm._v("流程任务")])
                                          : _vm._e(),
                                        scope.row.taskType < "0"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.taskType)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "taskProname"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.proId !== "0"
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    scope.row.project.proname,
                                                  placement: "bottom",
                                                  "popper-class": "texttooltip",
                                                  "open-delay": 500,
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "scope-content-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.project
                                                          .proname
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _c("span", {
                                              staticClass: "scope-content-text",
                                            }),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "correlationtaskType"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "150",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scope-content",
                                        staticStyle: {
                                          "justify-content": "center",
                                        },
                                      },
                                      [
                                        scope.row.taskVo.proTypeId === "2001"
                                          ? _c("span", [_vm._v("敏捷任务")])
                                          : scope.row.taskVo.taskType === "0"
                                          ? _c("span", [_vm._v("标准任务")])
                                          : scope.row.taskVo.taskType === "1"
                                          ? _c("span", [_vm._v("流程任务")])
                                          : scope.row.taskVo.proTypeId === "0"
                                          ? _c("span", [_vm._v("标准任务")])
                                          : scope.row.taskVo.proTypeId === "1"
                                          ? _c("span", [_vm._v("流程任务")])
                                          : _vm._e(),
                                        scope.row.taskVo.taskType < "0"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.taskVo.taskType
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "status"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "120",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.getStatusText(scope.row))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "subtaskStatus"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "190",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.getStatusText(scope.row))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "correlationstatus"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "120",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getStatusText(
                                                scope.row.taskVo
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "associated" &&
                        _vm.table_config.delFlag != "2"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "15%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c("span", [
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-jiechuguanlianxiang",
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.dissociated(
                                                  scope.row.objectId
                                                )
                                              },
                                            },
                                          }),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "fileName"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "40%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.fileName,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.fileName)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "fileFormat"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "40%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      _vm._l(
                                        _vm.getTypeTexts(scope.row.type),
                                        function (text, index) {
                                          return _c(
                                            "span",
                                            {
                                              key: index,
                                              staticClass: "scope-content-text",
                                            },
                                            [_vm._v(" " + _vm._s(text) + " ")]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "nodeName"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "40%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.nodeName,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.nodeName)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "createDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "35%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "scope-content-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.createDate.substring(
                                                  0,
                                                  10
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "delete" &&
                        _vm.table_config.delFlag != "2"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "30%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: "权限设置",
                                              placement: "top",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-quanxianshezhi custom_icon",
                                              staticStyle: {
                                                color: "#909090",
                                                cursor: "pointer",
                                                "margin-right": "15px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.setFile(scope.row)
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              "popper-class": "texttooltip",
                                              content: "删除文件",
                                              placement: "top",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _vm.corpId ===
                                            "wpbcaOGAAAJFN7JTFH_DOhACICDp_PUg"
                                              ? _c("span", [
                                                  _vm.drawer.info.editFlag ===
                                                  true
                                                    ? _c("i", {
                                                        staticClass:
                                                          "iconfont icon-shanchu1",
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.deleFile(
                                                              scope.row
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ])
                                              : _c("span", [
                                                  _c("i", {
                                                    staticClass:
                                                      "iconfont icon-shanchu1",
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.deleFile(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "deletePro" &&
                        _vm.table_config.delFlag != "2"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "30%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: "权限设置",
                                              placement: "top",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-quanxianshezhi custom_icon",
                                              staticStyle: {
                                                color: "#909090",
                                                cursor: "pointer",
                                                "margin-right": "15px",
                                                "margin-left": "10px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.setFile(scope.row)
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              "popper-class": "texttooltip",
                                              content: "删除文件",
                                              placement: "top",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _vm.drawer.info.nodeStatus !==
                                              "2" &&
                                            _vm.UserData.corpId !==
                                              "wpbcaOGAAAJFN7JTFH_DOhACICDp_PUg"
                                              ? _c("i", {
                                                  staticClass:
                                                    "iconfont icon-shanchu1",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.deleFile(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "proRate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "35%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scope-content",
                                        staticStyle: { "margin-left": "20px" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.progressRate) +
                                            "% "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "cycleNumber"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "25%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _vm._v(
                                          " 第" +
                                            _vm._s(scope.$index + 1) +
                                            "次 "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "realityWorkTime"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "25%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.realityWorkTime
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.realityWorkTime
                                                ) +
                                                "天 "
                                            ),
                                          ]
                                        )
                                      : !scope.row.realityWorkTime
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.realityWorkTime
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "nodeCreateDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "35%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.createDate
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.createDate.substring(
                                                    0,
                                                    10
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "remainDays"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "25%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.remainDays) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "depositDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "45%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.depositDate
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.depositDate.substring(
                                                    0,
                                                    10
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "drawingDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "45%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.drawingDate
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.drawingDate.substring(
                                                    0,
                                                    10
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "flowNames"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "45%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.flowNames,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.nodeName)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "35%",
                            "render-header": item.render_header,
                          },
                        }),
                  ]
                }),
              ]
            : [
                _vm._l(_vm.table_config.thead, function (item) {
                  return [
                    item.prop === "taskname"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "45%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.taskname,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(scope.row.taskname) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "scpc-operate-icon" },
                                          [
                                            scope.row.overdueFlag == 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "task_within",
                                                  },
                                                  [_vm._v("逾")]
                                                )
                                              : _vm._e(),
                                            scope.row.collectFlag == "1"
                                              ? _c("span", [
                                                  _c("i", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .collectFlag == 1,
                                                        expression:
                                                          "scope.row.collectFlag == 1",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "iconfont icon-shoucang1",
                                                    staticStyle: {
                                                      color: "#ffb83e",
                                                      "margin-right": "12px",
                                                    },
                                                  }),
                                                ])
                                              : _vm._e(),
                                            scope.row.milestone === "1"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      padding: "0 6px",
                                                    },
                                                  },
                                                  [
                                                    scope.row.milestone == "1"
                                                      ? _c("i", {
                                                          staticClass:
                                                            "iconfont icon-lichengbei-qizhi drawer_icon",
                                                          staticStyle: {
                                                            color: "#2878ff",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                            scope.row.taskType === "1"
                                              ? _c("i", {
                                                  staticClass:
                                                    "iconfont icon-liuchengrenwu liuchen_icon",
                                                  staticStyle: {
                                                    color:
                                                      "rgba(28, 106, 235, 1)",
                                                    padding: "0 6px",
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.config.figureFun(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "subtaskTaskname"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "140",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.taskname,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.taskname)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "scpc-operate-icon" },
                                          [
                                            scope.row.overdueFlag == 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "task_within",
                                                  },
                                                  [_vm._v("逾")]
                                                )
                                              : _vm._e(),
                                            scope.row.collectFlag == "1"
                                              ? _c("span", [
                                                  _c("i", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .collectFlag == 1,
                                                        expression:
                                                          "scope.row.collectFlag == 1",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "iconfont icon-shoucang1",
                                                    staticStyle: {
                                                      color: "#ffb83e",
                                                      "margin-right": "12px",
                                                    },
                                                  }),
                                                ])
                                              : _vm._e(),
                                            scope.row.milestone === "1"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      padding: "0 6px",
                                                    },
                                                  },
                                                  [
                                                    scope.row.milestone == "1"
                                                      ? _c("i", {
                                                          staticClass:
                                                            "iconfont icon-lichengbei-qizhi drawer_icon",
                                                          staticStyle: {
                                                            color: "#2878ff",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                            scope.row.taskType === "1"
                                              ? _c("i", {
                                                  staticClass:
                                                    "iconfont icon-liuchengrenwu liuchen_icon",
                                                  staticStyle: {
                                                    color:
                                                      "rgba(28, 106, 235, 1)",
                                                    padding: "0 6px",
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.config.figureFun(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "correlationTaskname"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "35%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                scope.row.taskVo.taskname,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.taskVo.taskname
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "scpc-operate-icon" },
                                          [
                                            scope.row.taskVo.overdueFlag == 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "task_within",
                                                  },
                                                  [_vm._v("逾")]
                                                )
                                              : _vm._e(),
                                            scope.row.taskVo.collectFlag == "1"
                                              ? _c("span", [
                                                  _c("i", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row.taskVo
                                                            .collectFlag == 1,
                                                        expression:
                                                          "scope.row.taskVo.collectFlag == 1",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "iconfont icon-shoucang1",
                                                    staticStyle: {
                                                      color: "#ffb83e",
                                                      "margin-right": "12px",
                                                    },
                                                  }),
                                                ])
                                              : _vm._e(),
                                            scope.row.taskVo.milestone === "1"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      padding: "0 6px",
                                                    },
                                                  },
                                                  [
                                                    scope.row.taskVo
                                                      .milestone == "1"
                                                      ? _c("i", {
                                                          staticClass:
                                                            "iconfont icon-lichengbei-qizhi drawer_icon",
                                                          staticStyle: {
                                                            color: "#2878ff",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                            scope.row.taskVo.taskType === "1"
                                              ? _c("i", {
                                                  staticClass:
                                                    "iconfont icon-liuchengrenwu liuchen_icon",
                                                  staticStyle: {
                                                    color:
                                                      "rgba(28, 106, 235, 1)",
                                                    padding: "0 6px",
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.config.figureFun(
                                                        scope.row.taskVo
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "taskNumber"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "170",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "scope-content-id" },
                                      [_vm._v(_vm._s(scope.row.taskNumber))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "proname"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "110",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.proname,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.proname)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "scpc-operate-icon" },
                                          [
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    scope.row.collectFlag == 1,
                                                  expression:
                                                    "scope.row.collectFlag == 1",
                                                },
                                              ],
                                              staticClass:
                                                "iconfont icon-shoucang1",
                                              staticStyle: {
                                                color: "#ffb83e",
                                                "margin-right": "12px",
                                              },
                                            }),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: scope.row.collect,
                                                  expression:
                                                    "scope.row.collect",
                                                },
                                              ],
                                              staticClass:
                                                "iconfont icon-lichengbei-qizhi",
                                              staticStyle: {
                                                color: "#2978ff",
                                                "margin-right": "12px",
                                              },
                                            }),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: scope.row.collect,
                                                  expression:
                                                    "scope.row.collect",
                                                },
                                              ],
                                              staticClass:
                                                "iconfont icon-liuchengrenwu",
                                              staticStyle: {
                                                color: "rgba(28, 106, 235, 1)",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.config.figureFun(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "proNumber"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "220",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "scope-content-id" },
                                      [_vm._v(_vm._s(scope.row.proNumber))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "planStartDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "33%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "scope-content-id" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.proNumber &&
                                              scope.row.planStartDate
                                              ? scope.row.planStartDate.substring(
                                                  0,
                                                  10
                                                )
                                              : scope.row.planStartDate
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "planEndDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "45%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.corpId ===
                                      "ding379884b8b194a55f35c2f4657eb6378f" &&
                                    scope.row.project
                                      ? _c(
                                          "span",
                                          { staticClass: "scope-content-id" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.project.planEndDate.substring(
                                                  0,
                                                  10
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "scope-content-id" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.proNumber &&
                                                  scope.row.planEndDate
                                                  ? scope.row.planEndDate.substring(
                                                      0,
                                                      10
                                                    )
                                                  : scope.row.planEndDate
                                              )
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "prodPlanEndDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "45%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return scope.row.prodPlanEndDate
                                    ? [
                                        _c(
                                          "span",
                                          { staticClass: "scope-content-id" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.prodPlanEndDate.substring(
                                                  0,
                                                  10
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    : undefined
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "subtaskPlanEndDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "220",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "scope-content-id" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.proNumber &&
                                              scope.row.planEndDate
                                              ? scope.row.planEndDate.substring(
                                                  0,
                                                  10
                                                )
                                              : scope.row.planEndDate
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "createUser"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "30%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "scpc-operate-photo",
                                            staticStyle: {
                                              "padding-right": "2px",
                                            },
                                          },
                                          [
                                            scope.row.createUser &&
                                            scope.row.createUser.avatar != "" &&
                                            scope.row.createUser.avatar != null
                                              ? _c("div", [
                                                  _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      src: scope.row.createUser
                                                        .avatar,
                                                    },
                                                  }),
                                                ])
                                              : _c(
                                                  "div",
                                                  { staticClass: "img" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.createUser.name.substring(
                                                            0,
                                                            1
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid:
                                                      scope.row.createUser.name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : scope.row.createUser &&
                                            _vm.channel !== "wechat"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.createUser.name
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "subtaskCreateUser"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "28%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "scpc-operate-photo",
                                            staticStyle: {
                                              "padding-right": "2px",
                                            },
                                          },
                                          [
                                            scope.row.createUser &&
                                            scope.row.createUser.avatar != "" &&
                                            scope.row.createUser.avatar != null
                                              ? _c("div", [
                                                  _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      src: scope.row.createUser
                                                        .avatar,
                                                    },
                                                  }),
                                                ])
                                              : _c(
                                                  "div",
                                                  { staticClass: "img" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.createUser.name.substring(
                                                            0,
                                                            1
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid:
                                                      scope.row.createUser.name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.createUser.name
                                                  )
                                                ),
                                              ]
                                            ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "correlationCreateUser"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "28%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "scpc-operate-photo",
                                            staticStyle: {
                                              "padding-right": "2px",
                                            },
                                          },
                                          [
                                            scope.row.taskVo.createUser &&
                                            scope.row.taskVo.createUser
                                              .avatar != "" &&
                                            scope.row.taskVo.createUser
                                              .avatar != null
                                              ? _c("div", [
                                                  _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      src: scope.row.taskVo
                                                        .createUser.avatar,
                                                    },
                                                  }),
                                                ])
                                              : _c(
                                                  "div",
                                                  { staticClass: "img" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.taskVo.createUser.name.substring(
                                                            0,
                                                            1
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid:
                                                      scope.row.taskVo
                                                        .createUser.name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.taskVo.createUser
                                                      .name
                                                  )
                                                ),
                                              ]
                                            ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "principalUser"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "120",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "scpc-operate-photo" },
                                          [
                                            scope.row.principalUser.avatar &&
                                            scope.row.principalUser.avatar !=
                                              "" &&
                                            scope.row.principalUser.avatar !=
                                              null
                                              ? _c("div", [
                                                  _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      src: scope.row
                                                        .principalUser.avatar,
                                                    },
                                                  }),
                                                ])
                                              : _c(
                                                  "div",
                                                  { staticClass: "img" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.principalUser.name.substring(
                                                            0,
                                                            1
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid:
                                                      scope.row.principalUser
                                                        .name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          { staticClass: "scope-content-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.principalUser.name
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "executorUserList"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "30%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          overflow: "hidden",
                                          "align-items": "center",
                                          "text-overflow": "ellipsis",
                                          "white-space": "nowrap",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "scpc-operate-photos",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  width: "6px",
                                                },
                                              },
                                              _vm._l(
                                                scope.row.executorUserList,
                                                function (item1, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "scope-content",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "scpc-operate-photo",
                                                        },
                                                        [
                                                          item1.avatar &&
                                                          item1.avatar != "" &&
                                                          item1.avatar != null
                                                            ? _c("div", [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: item1.avatar,
                                                                  },
                                                                }),
                                                              ])
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "img",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item1.name.substring(
                                                                          0,
                                                                          1
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "min-width": "55px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                  "white-space": "nowrap",
                                                  "margin-left": "8px",
                                                },
                                              },
                                              _vm._l(
                                                scope.row.executorUserList,
                                                function (item1, index) {
                                                  return _c(
                                                    "span",
                                                    { key: index },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "scope-content-text",
                                                        },
                                                        [
                                                          _vm.channel ===
                                                          "wechat"
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "ww-open-data",
                                                                    {
                                                                      attrs: {
                                                                        type: "userName",
                                                                        openid:
                                                                          item1.name,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item1.name
                                                                  )
                                                                ),
                                                              ]),
                                                          index <
                                                          scope.row
                                                            .executorUserList
                                                            .length -
                                                            1
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-right":
                                                                      "5px",
                                                                  },
                                                                },
                                                                [_vm._v(",")]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "planWorkTime"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "33%",
                            "render-header": item.render_header,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        scope.row.planWorkTime == "" ||
                                        scope.row.planWorkTime == null
                                          ? _c("div", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "scope-content-text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.planWorkTime
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ])
                                          : _c("div", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "scope-content-text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.planWorkTime
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("span", [_vm._v("天")]),
                                            ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "taskType"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "150",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scope-content",
                                        staticStyle: {
                                          "justify-content": "center",
                                        },
                                      },
                                      [
                                        scope.row.proTypeId === "2001"
                                          ? _c("span", [_vm._v("敏捷任务")])
                                          : scope.row.taskType === "0"
                                          ? _c("span", [_vm._v("标准任务")])
                                          : scope.row.taskType === "1"
                                          ? _c("span", [_vm._v("流程任务")])
                                          : scope.row.proTypeId === "0"
                                          ? _c("span", [_vm._v("标准任务")])
                                          : scope.row.proTypeId === "1"
                                          ? _c("span", [_vm._v("流程任务")])
                                          : _vm._e(),
                                        scope.row.taskType < "0"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.taskType)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "taskProname"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.proId !== "0"
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    scope.row.project.proname,
                                                  placement: "bottom",
                                                  "popper-class": "texttooltip",
                                                  "open-delay": 500,
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "scope-content-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.project
                                                          .proname
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _c("span", {
                                              staticClass: "scope-content-text",
                                            }),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "correlationtaskType"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "150",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scope-content",
                                        staticStyle: {
                                          "justify-content": "center",
                                        },
                                      },
                                      [
                                        scope.row.taskVo.proTypeId === "2001"
                                          ? _c("span", [_vm._v("敏捷任务")])
                                          : scope.row.taskVo.taskType === "0"
                                          ? _c("span", [_vm._v("标准任务")])
                                          : scope.row.taskVo.taskType === "1"
                                          ? _c("span", [_vm._v("流程任务")])
                                          : scope.row.taskVo.proTypeId === "0"
                                          ? _c("span", [_vm._v("标准任务")])
                                          : scope.row.taskVo.proTypeId === "1"
                                          ? _c("span", [_vm._v("流程任务")])
                                          : _vm._e(),
                                        scope.row.taskVo.taskType < "0"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.taskVo.taskType
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "status"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "120",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.getStatusText(scope.row))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "subtaskStatus"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "190",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.getStatusText(scope.row))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "correlationstatus"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "120",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getStatusText(
                                                scope.row.taskVo
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "projectName"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "270",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "scope-content-text" },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.projectName)
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "scpc-operate-icon" },
                                          [
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: scope.row.collect,
                                                  expression:
                                                    "scope.row.collect",
                                                },
                                              ],
                                              staticClass:
                                                "iconfont icon-shoucang1",
                                              staticStyle: {
                                                color: "#ffb83e",
                                                "margin-right": "12px",
                                              },
                                            }),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: scope.row.collect,
                                                  expression:
                                                    "scope.row.collect",
                                                },
                                              ],
                                              staticClass:
                                                "iconfont icon-lichengbei-qizhi",
                                              staticStyle: {
                                                color: "#2978ff",
                                                "margin-right": "12px",
                                              },
                                            }),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: scope.row.collect,
                                                  expression:
                                                    "scope.row.collect",
                                                },
                                              ],
                                              staticClass:
                                                "iconfont icon-liuchengrenwu",
                                              staticStyle: {
                                                color: "rgba(28, 106, 235, 1)",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.config.figureFun(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "complete"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "220",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c("el-progress", {
                                          staticStyle: { width: "300px" },
                                          attrs: {
                                            "stroke-width": 12,
                                            percentage: scope.row.progressRate,
                                            color: "#2878ff",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "projectSTime"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "200",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "scope-content-text" },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.projectSTime)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "projecteTime"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            width: "200",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "scope-content-text" },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.projecteTime)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "associated" &&
                        _vm.table_config.delFlag != "2"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "15%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c("span", [
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-jiechuguanlianxiang",
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.dissociated(
                                                  scope.row.objectId
                                                )
                                              },
                                            },
                                          }),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "fileName"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "40%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.fileName,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.fileName)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "fileFormat"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "40%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      _vm._l(
                                        _vm.getTypeTexts(scope.row.type),
                                        function (text, index) {
                                          return _c(
                                            "span",
                                            {
                                              key: index,
                                              staticClass: "scope-content-text",
                                            },
                                            [_vm._v(" " + _vm._s(text) + " ")]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "nodeName"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "40%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.nodeName,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.nodeName)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "createDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "35%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "scope-content-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.createDate.substring(
                                                  0,
                                                  10
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "delete" &&
                        _vm.table_config.delFlag != "2"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "30%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: "权限设置",
                                              placement: "top",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-quanxianshezhi custom_icon",
                                              staticStyle: {
                                                color: "#909090",
                                                cursor: "pointer",
                                                "margin-right": "15px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.setFile(scope.row)
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              "popper-class": "texttooltip",
                                              content: "删除文件",
                                              placement: "top",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _vm.corpId ===
                                            "wpbcaOGAAAJFN7JTFH_DOhACICDp_PUg"
                                              ? _c("span", [
                                                  _vm.drawer.info.editFlag ===
                                                  true
                                                    ? _c("i", {
                                                        staticClass:
                                                          "iconfont icon-shanchu1",
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.deleFile(
                                                              scope.row
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ])
                                              : _c("span", [
                                                  _vm.drawer.info.status !== "2"
                                                    ? _c("i", {
                                                        staticClass:
                                                          "iconfont icon-shanchu1",
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.deleFile(
                                                              scope.row
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "deletePro" &&
                        _vm.table_config.delFlag != "2"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "30%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: "权限设置",
                                              placement: "top",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-quanxianshezhi custom_icon",
                                              staticStyle: {
                                                color: "#909090",
                                                cursor: "pointer",
                                                "margin-right": "15px",
                                                "margin-left": "10px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.setFile(scope.row)
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              "popper-class": "texttooltip",
                                              content: "删除文件",
                                              placement: "top",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _vm.drawer.info.nodeStatus &&
                                            _vm.drawer.info.nodeStatus !==
                                              "2" &&
                                            _vm.UserData.corpId !==
                                              "wpbcaOGAAAJFN7JTFH_DOhACICDp_PUg"
                                              ? _c("i", {
                                                  staticClass:
                                                    "iconfont icon-shanchu1",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.deleFile(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "proRate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "30%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scope-content",
                                        staticStyle: { "margin-left": "20px" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.progressRate) +
                                            "% "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "cycleNumber"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "25%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _vm._v(
                                          " 第" +
                                            _vm._s(scope.$index + 1) +
                                            "次 "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "realityWorkTime"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "25%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.realityWorkTime
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.realityWorkTime
                                                ) +
                                                "天 "
                                            ),
                                          ]
                                        )
                                      : !scope.row.realityWorkTime
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.realityWorkTime
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "nodeCreateDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "35%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.createDate
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.createDate.substring(
                                                    0,
                                                    10
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "remainDays"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "25%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.remainDays) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "depositDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "45%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.depositDate
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.depositDate.substring(
                                                    0,
                                                    10
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "drawingDate"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "45%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.drawingDate
                                      ? _c(
                                          "div",
                                          { staticClass: "scope-content" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.drawingDate.substring(
                                                    0,
                                                    10
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : item.prop === "flowNames"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "35%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-content" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.flowNames,
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.flowNames)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            prop: item.prop,
                            label: item.label,
                            "min-width": "35%",
                            "render-header": item.render_header,
                          },
                        }),
                  ]
                }),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }